import { render, staticRenderFns } from "./submission-detail.vue?vue&type=template&id=310bf16b&scoped=true&"
import script from "./submission-detail.vue?vue&type=script&lang=js&"
export * from "./submission-detail.vue?vue&type=script&lang=js&"
import style0 from "./submission-detail.vue?vue&type=style&index=0&id=310bf16b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310bf16b",
  null
  
)

export default component.exports